
        // ─── Splash → App transition ──────────────────
        import { dungeonMatrix } from '/src/splash/dungeon-matrix.ts'

        // Start matrix rain
        dungeonMatrix.init()
        dungeonMatrix.start()

        // START button handler
        document.getElementById('startBtn').addEventListener('click', () => {
            const splash = document.getElementById('welcomeScreen')
            const app = document.getElementById('appContainer')

            // Fade out splash
            splash.style.transition = 'opacity 0.6s ease'
            splash.style.opacity = '0'

            // Fade in app
            setTimeout(() => {
                app.classList.add('visible')
            }, 200)

            // Remove splash from DOM
            setTimeout(() => {
                dungeonMatrix.stop()
                splash.remove()
            }, 800)
        })

        // ─── Collapsible panel toggles ────────────────
        document.querySelectorAll('.panel-toggle').forEach(toggle => {
            toggle.addEventListener('click', () => {
                const targetId = toggle.dataset.target
                const content = document.getElementById(targetId)
                if (!content) return

                toggle.classList.toggle('active')
                content.classList.toggle('open')
            })
        })

        // ─── Advanced seed toggle ────────────────────
        const advToggle = document.getElementById('advancedToggle')
        const advContent = document.getElementById('advancedContent')
        if (advToggle && advContent) {
            advToggle.addEventListener('click', () => {
                advToggle.classList.toggle('open')
                advContent.classList.toggle('open')
            })
        }
    